import { render, staticRenderFns } from "./DescriptionItemModal.vue?vue&type=template&id=dc5df424"
import script from "../../../scripts/partials/add-capacity-equipment-steps/DescriptionItemModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/add-capacity-equipment-steps/DescriptionItemModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports